import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const tracingLineStatusesAdapter = getAdapter({ idFieldName:'value' });

const tracingLineStatusesSlice = createSlice({
    name: 'tracingLineStatuses',
    initialState: tracingLineStatusesAdapter.getInitialState(),
    reducers: {
        setTracingLineStatuses: (state, { payload: { tracingLineStatuses } }) => {
            tracingLineStatusesAdapter.setAll(state, tracingLineStatuses);
        },
    },
});

const selectors = tracingLineStatusesAdapter.getSelectors(({ tracingLineStatuses }) => tracingLineStatuses);

export const getTracingLineStatuses = (state) => selectors.selectAll(state);

export const {
    setTracingLineStatuses,
} = tracingLineStatusesSlice.actions;

export default tracingLineStatusesSlice.reducer;
